import lpevents from './lpevents';
import Cookies from 'universal-cookie';

let localStorageAvailable = true;

if (typeof (Storage) === 'undefined') localStorageAvailable = false;
try {
  // try to use localStorage
  localStorage.setItem('localStorageAvailable', 'true');
  localStorage.getItem('localStorageAvailable');
  localStorage.removeItem('localStorageAvailable');
} catch (e) {
  console.log('You are in Privacy Mode\nPlease deactivate Privacy Mode and then reload the page.');
  localStorageAvailable = false;
}

export default function AbTest() {
  this.tests = {};
  this.session_prefix = 'lp_ab_';
}

/*
 * Registers Test
 */
AbTest.prototype.registerTest = function (name) {
  this.tests[name] = [];
  this.current_test = name;
  return this;
};

/*
 * Registers variation
 */
AbTest.prototype.registerVar = function (name, percent) {
  if (!this.current_test) { return false; }
  this.tests[this.current_test].push({
    name,
    percent,
  });
  return true;
};

/**
 * Register data from cookie
 */
AbTest.prototype.registerFromCookie = function (abTestName, oldValue = 'Old') {
  const cookies = decodeURIComponent(document.cookie).split(';');
  let abTestCookieValue;
  cookies.forEach(cookie => {
    const [cookieKey, cookieValue] = cookie.split('=')
    if (cookieKey.indexOf(abTestName) > -1) {
      abTestCookieValue = cookieValue
    }
  })
  var mp = {};

  // Make sur to have Cookies
  const cookiesUniversal = new Cookies();
  if (!abTestCookieValue && cookiesUniversal.get(abTestName)){
    abTestCookieValue = cookiesUniversal.get(abTestName)
  }
  
  if (abTestName && typeof window[abTestName] === 'undefined') {
    window[abTestName] = abTestCookieValue
  }
  if (abTestCookieValue) {
    // Mixpanel tracking
    mp["AB: "+abTestName] = abTestCookieValue;
  } else {
    mp["AB: "+abTestName] = oldValue;
  }
    lpevents.register(mp);

}

/*
 * Get variation
 */
AbTest.prototype.getVar = function (testName) {
  // if( typeof Storage != 'function' ) return false;

  const test = this.tests[testName];


  let variation = null;
  if (typeof (test) === 'undefined') { return false; }

  // Checking if test exists in localStorage
  if (localStorageAvailable) {
    if (localStorage.getItem((this.session_prefix + testName).toLowerCase().replace(' ', '_'))) {
      variation = localStorage.getItem((this.session_prefix + testName).toLowerCase().replace(' ', '_'));

      return variation;
    }
  }

  // Counts
  let lastPercent = 0;
  const percent = Math.floor((Math.random() * 100) + 1);

  // Reading variations list
  for (let i = 0; i < test.length; i += 1) {
    if (percent > lastPercent && percent <= (test[i].percent + lastPercent)) {
      variation = test[i].name;
      break;
    } else lastPercent += test[i].percent;
  }

  if (variation === null) variation = test[0].name;

  // Adding to localStorage
  if (localStorageAvailable) localStorage.setItem((this.session_prefix + testName).toLowerCase().replace(' ', '_'), variation);

  // Mixpanel tracking
  const mp = {};
  mp[`AB: ${testName}`] = variation;
  lpevents.register(mp);

  return variation;
};

// Initiation ab lib



// WEBPACK FOOTER //
// ./src/tracking/abTest.js